<div class="trigger" (click)="openToolbox()">
  <ng-container [ngSwitch]="triggerName">
    <ng-container *ngSwitchCase="'ProductChooser'">
      <mat-icon svgIcon="products"></mat-icon>
      {{ 'i18n.toolbox.productChooser.triggerText' | translate }}
    </ng-container>

    <ng-container *ngSwitchCase="'Layout'">
      <mat-icon svgIcon="layouts"></mat-icon>
      {{ 'i18n.toolbox.layout.triggerText' | translate }}
    </ng-container>

    <ng-container *ngSwitchCase="'Preview'">
      <mat-icon svgIcon="preview"></mat-icon>
      {{ 'i18n.toolbox.preview.title' | translate }}
    </ng-container>
  </ng-container>
</div>



// WEBPACK FOOTER //
// ./src/app/toolboxes/toolbox-trigger/toolbox-trigger.component.html